export default class Thumbor {
  constructor(config) {
    this.config = config
    this.files = config.files
    this.enabled = !!this.files.thumbServer
    this.url = this.files.thumbServerUrl
    this.horizontalAlign = null // left | right ====> dont use center
    this.verticalAlign = null // top | bottom ====> dont use middle

    this.watermarkConfig = {
      enabled: !!this.files.watermarkUrl,
      imageUrl: this.files.watermarkUrl,
      opacity: 50,
      margin: 50,
      horizontalAlign: 'left', // left | right
      verticalAlign: 'bottom', // bottom | top
      get horizontalMargin() {
        if (this.horizontalAlign === 'left') return this.margin
        return -this.margin
      },
      get verticalMargin() {
        if (this.verticalAlign === 'top') return this.margin
        return -this.margin
      }
    }
  }

  createUrl(options) {
    if (!options || !options.src) return null
    const baseUrl = options.baseUrl || this.url
    const urlParts = [baseUrl]

    // Add Size And Crop Config
    const cropUrl = this.crop(options)
    if (cropUrl) urlParts.push(cropUrl)

    // Add Format And Effects And Watermark Config
    const filtersUrl = this.filters(options)
    if (filtersUrl) urlParts.push(filtersUrl)

    // Add Image Orginal Src Config
    let imageSrc = `${this.files.prefixUrl || ''}/files/${options.src}`
    urlParts.push(imageSrc)

    return urlParts.join('/')
  }

  filters(options) {
    const {format, watermark, gif, effects, webpCompatible} = options
    const filtersUrl = ['filters']

    if (format) {
      if (gif) filtersUrl.push(`gifv(${format})`)
      else if (webpCompatible) filtersUrl.push(`format(${format})`)
    }

    if (effects && Object.keys(effects).length) {
      Object.entries(effects).forEach(([key, value]) => {
        filtersUrl.push(`${key}(${value})`)
      })
    }

    if (watermark && this.watermark) {
      filtersUrl.push(this.watermark)
    }

    if (filtersUrl.length === 1) return null
    return filtersUrl.join(':')
  }

  get watermark() {
    const {enabled, horizontalMargin, verticalMargin, opacity, imageUrl} = this.watermarkConfig
    if (!enabled) return null

    return `watermark(${imageUrl}, ${horizontalMargin}, ${verticalMargin}, ${opacity})`
  }

  crop(options) {
    const {fitIn, width, height} = options
    const urlParts = []
    if (fitIn) urlParts.push('fit-in')
    if (width && height) urlParts.push(`${width}x${height}`)
    if (this.horizontalAlign) urlParts.push(this.horizontalAlign)
    if (this.verticalAlign) urlParts.push(this.verticalAlign)

    return urlParts.join('/')
  }
}
